<template>

    <CForm>
        <div class="overflow-hidden border border-gray-300 rounded-md">

            <div class="flex items-center bg-gray-100">
                <div class="w-2/5 py-2 font-bold pl-2">Башня</div>
                <div class="w-2/5 py-2 font-bold">Мин сумма заказа (руб)</div>
                <div class="w-1/5 py-2 font-bold">Удаление</div>
            </div>

            <div
                v-for="(item, index) in list"
                :key="`item-${index}`"
                class="flex items-center h-10 px-2 py-4 border-t border-gray-300"
            >
                <div class="w-100 flex items-center">
                    <div class="w-2/5">
                        <CSelect
                            :value.sync="item.tower_id"
                            inline
                            :options="addresses"
                            placeholder="Башня"
                            class="m-0 mr-2" />
                    </div>
                    <div class="w-2/5">
                        <CInput v-model.number="item.min_price" class="m-0 mr-2" />
                    </div>
                    <div class="w-1/5">
                        <CButton
                            variant="outline"
                            color="danger"
                            class="mr-3"
                            @click="remove(index)"
                        >Удалить</CButton>
                    </div>
                </div>
            </div>

            <div class="w-100 p-2 flex items-center" style="justify-content: space-between;">
                <CButton
                    color="primary"
                    class="mr-3"
                    @click="save"
                >Сохранить</CButton>
                <CButton
                    variant="outline"
                    color="success"
                    @click="add"
                >Добавить</CButton>
            </div>
        </div>

        <CElementCover
            v-if="isPending"
            :opacity="0.8"
        >
            <div class="flex items-center">
                <CSpinner size="sm" />
                <p class="ml-2 text-xl">Сохранение... </p>
            </div>
        </CElementCover>
    </CForm>

</template>

<script>
    export default {

        name: 'Delivery',

        props: {
            entityType: {
                type: String,
                default: ''
            },
            entityId: {
                type: Number,
                default: null
            },
            addresses: {
                type: Array,
                default: () => ([])
            },
            deliveries: {
                type: Array,
                default: () => ([])
            },
            settings: {
                type: Array,
                default: () => ([])
            }
        },
  
        data () {
            return {
                list: [],
                removed: [],
                isPending: false
            }
        },

        watch: {
            settings: {
                deep: true,
                handler: 'setList'
            }
        },

        mounted() {
        },
        
        methods: {
            setList() {
                this.list = this.settings || [];
            },
            add() {
                this.list.push({ 
                    type: 'min_price',
                    entity_type: this.entityType,
                    entity_id: this.entityId,
                    tower_id: null,
                    delivery_type: null,
                    min_price: 0
                });
            },

            remove(index) {
                if(this.list[index].id) {
                    this.removed.push(this.list[index].id);
                }
                this.list.splice(index, 1);
            },

            async save() {
                this.isPending = true;
                for(const id of this.removed) {
                    await this.axios.delete(`/entity-delivery-settings/${id}`);
                }
                for(const item of this.list) {
                    if(item.id) {
                        await this.axios.put(`/entity-delivery-settings/${item.id}`, item);
                    } else {
                        await this.axios.post('/entity-delivery-settings', item);
                    }
                }
                this.$emit('reload');
                this.isPending = false;
            }
        }
    }
</script>
